export const layout = {
  container: {
    mx: 'auto',
    maxWidth: 'container.lg',
    p: [1, 2],
  },
}
